import { render } from "./ribbonsRight.vue?vue&type=template&id=05e97340"
import script from "./ribbonsRight.vue?vue&type=script&lang=js"
export * from "./ribbonsRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__